import { MbColor } from '../../tailwind/enums/color-enum'

export type BackgroundColors = MbColor.white | MbColor.grey

export const backgroundColors = {
    [MbColor.white]: 'tw-bg-white',
    [MbColor.grey]: 'tw-bg-grey',
} as const satisfies Partial<Record<BackgroundColors, string>>
